export default "__VITE_ASSET__CyPKqkS___"